// extracted by mini-css-extract-plugin
module.exports = {"modal":"Status_modal__3BNIJ","label":"Status_label__4_Ldy","name":"Status_name__YhaCA","statusIcon":"Status_statusIcon__3fSfM"};